import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

export const personalisationOptions = css`
  margin: 0;
  list-style: none;
  padding: 0;
`;

export const personalisationOption = css`
  list-style: none;
  margin: 0 0 ${spacing.sm}px 0;
  padding: ${spacing.sm}px 0 0;
`;

export const groupLabel = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  text-transform: capitalize;
  ${theme.responsiveText.BODY.XS}
  margin: 0 0 ${spacing.xs}px 0;
`;

export const radioGroup = css`
  > div:last-of-type {
    margin: 0;
  }
`;

export const priceOperator = css`
  ${responsiveText.BODY.SM};
  margin-right: 2px;

  &[data-is-negative='false'] {
    ${responsiveText.HEADING.XS};
  }
`;

export const priceModifier = css`
  display: flex;
`;

export const feedbackContainer = css`
  margin: 0;
`;

export const selectionContainer = css`
  position: relative;
  padding: ${spacing.md}px;
  border-radius: 10px;
  border: solid 1px var(--neutral-black-70);

  &[data-has-error],
  &[data-is-valid],
  [data-has-error],
  &[data-is-selected] {
    transition: border-color 0.15s ease-in, background-color 0.15s ease-in;
  }

  &:hover {
    border-color: var(--neutral-black-70);
  }

  &[data-has-error='true'] {
    border-color: var(--functional-red-base);

    [data-is-selected] {
      border-color: var(--functional-red-base);
    }
  }

  &[data-is-valid='true'] {
    border-color: var(--functional-green-base);
  }
`;

export const toggleButtonGroupDescription = css`
  display: none;
`;
